import { useEffect, useState } from "react";
import { Monitor } from "lucide-react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { desktopSupportsRaw } from "@/lib/desktopPrint";

// Panel visible solo dentro de Connect POS Desktop: elige la cola de Windows y el modo RAW/gráfico.
export const DesktopPrinterPanel = ({ settings, update }) => {
  const [printers, setPrinters] = useState([]);
  const [current, setCurrent] = useState("");
  const raw = desktopSupportsRaw();

  useEffect(() => {
    const api = window.electronAPI;
    api.listPrinters?.().then((l) => setPrinters(l || [])).catch(() => setPrinters([]));
    api.getAppInfo?.().then((i) => setCurrent(i?.printer || "")).catch(() => {});
  }, []);

  const choose = async (printer) => {
    const res = await window.electronAPI.setPrinter({ printer, paperSize: settings.paper_size });
    setCurrent(res?.printer || printer);
    toast.success(`Impresora de escritorio: ${printer}`);
  };

  return (
    <div className="space-y-2 rounded-lg border-2 border-primary/40 bg-primary/5 p-3" data-testid="printer-desktop-panel">
      <Label className="flex items-center gap-1.5"><Monitor size={14} className="text-primary" /> App de escritorio Connect</Label>
      <select value={current} onChange={(e) => choose(e.target.value)} data-testid="printer-desktop-select"
        className="h-9 w-full rounded-md border border-border bg-background px-2 text-sm">
        <option value="" disabled>Selecciona la tiquera…</option>
        {printers.map((p) => <option key={p.name} value={p.name}>{p.name}{p.isDefault ? " (predeterminada)" : ""}</option>)}
      </select>
      {raw ? (
        <div className="grid grid-cols-2 gap-2">
          {[["raw", "ESC/POS directo (RAW)", "Recomendado. Sirve con cualquier driver, incluso Generic / Text Only."],
            ["graphic", "Gráfico (driver)", "Solo si la tiquera tiene su driver oficial instalado."]].map(([mode, title, hint]) => (
            <button key={mode} type="button" onClick={() => update({ desktop_mode: mode })} data-testid={`printer-desktop-mode-${mode}`}
              className={`rounded-lg border-2 p-2 text-left transition-colors ${settings.desktop_mode === mode ? "border-primary bg-primary/10" : "border-border hover:border-primary/40"}`}>
              <div className="text-xs font-semibold">{title}</div>
              <div className="text-[10px] text-muted-foreground leading-snug">{hint}</div>
            </button>
          ))}
        </div>
      ) : (
        <div className="text-[11px] text-amber-600" data-testid="printer-desktop-outdated">
          Versión de la app sin modo RAW: actualiza Connect POS a 1.1.0 o superior para imprimir con cualquier driver.
        </div>
      )}
    </div>
  );
};

export default DesktopPrinterPanel;
